<template>
    <div class="content__audio__player">
        <audio ref="audio" :src="src">
        </audio>
        <div v-on:click="play()" class="content__audio__player__button">
            <svg v-if="!playing" class="content__audio__player__button__play" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path></svg>
            <svg v-if="playing" class="content__audio__player__button__pause" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"></path></svg>
        </div>
        <div class="content__audio__player__progress" v-on:click="seek" ref="progress">
            <div class="content__audio__player__progress__cursor" ref="cursor"></div>
            <div class="content__audio__player__progress__current" v-html="current"></div>
            <div class="content__audio__player__progress__end" v-html="end"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AudioPlayer',
        props: {
            src: {
                type: String
            },
        },
        data: function () {
            return {
                playing:false,
                current:'',
                end:'',
            }
        },
        watch: { 
            src: function() {
                this.playing=false;
                this.current='';
                this.end='';
            }
        },
        mounted() {
            const audio = this.$refs.audio;

            audio.addEventListener("play", () => {
                this.playing = true;
            });
            audio.addEventListener("pause", () => {
                this.playing = false;
            });
            audio.addEventListener("ended", () => {
                this.playing = false;
                this.current="00:00";
                if(this.$refs.cursor) {
                    this.$refs.cursor.style.left = "0%";
                }
            });
            audio.addEventListener("durationchange", () => {
                this.current = this._formatDuration(audio.currentTime);
                this.end = this._formatDuration(audio.duration);
                if(this.$refs.cursor) {
                    this.$refs.cursor.style.left = Math.round(100 / audio.duration * audio.currentTime) + "%";
                }
            });
            
            this.playerInterval = setInterval(() => {
                if(this.playing) {
                    const current = this._formatDuration(audio.currentTime);
                    if(current != this.current) {
                        this.current = current;
                        this.$refs.cursor.style.left = Math.round(100 / audio.duration * audio.currentTime) + "%";
                        this.current = this._formatDuration(audio.currentTime);
                    }
                }
            }, 250);
        },
        beforeDestroy () {
            clearInterval(this.playerInterval);
        },
        methods: {
            play() {
                const audio = this.$refs.audio;
                if(audio.paused === false) {
                    audio.pause();
                } else {
                    audio.play();
                }
            },
            seek(e) {
                const position = Math.round(100 / this.$refs.progress.offsetWidth * e.offsetX);

                if(this.$refs.audio.duration) {
                    this.$refs.cursor.style.left = position + "%";
                                        const current = this.$refs.audio.duration / 100 * position;
                    this.$refs.audio.currentTime = current;
                }
                
            },

            _formatDuration(duration) {
                let seconds = Math.floor(duration);
                let minutes = Math.floor(seconds / 60);
                if(minutes) {
                    seconds = seconds % 60;
                }
                if(minutes <= 9) minutes = '0' + minutes;
                if(seconds <= 9) seconds = '0' + seconds;
                return minutes + ':' + seconds;
            }
        }
    };
</script>
<style lang="scss">
    .content__audio__player {
        width:100%;

        &__button {
            display: flex;
            justify-content: center;
            align-items: center;
            height:120px;
            width:120px;
            margin:0 auto 30px auto;
            padding:20px;
            border: 6px solid #fff;
            border-radius: 100%;

            color:#fff;
            cursor: pointer;

            svg {
                width:100%;
                height:100%;
            }

            &__play {
                margin-left:12px;
            }
        }

        &__progress {
            position: relative;
            display: flex;
            justify-content: space-between;
            
            margin:10px 0;
            padding:25px 0 0 0;
            cursor:pointer;

            &::before {
                position: absolute;
                content:"";
                top:10px;
                left:0;
                right:0;
                height:4px;
                background-color: #fff;
            }

            &__cursor {
                position: absolute;
                top:5px;
                width:14px;
                height:14px;
                background-color: #fff;
                border-radius: 10px;
            }
        }
    }
</style>